import React, { useState } from "react";
import { withPrefix } from "gatsby";

import ShareModal from "../../molecules/share-modal/shareModal";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";
import DefaultImage from "../../../assets/images/not-found/Icono_vertical_portada_libro.jpg";

import "./cardEpisodeRotator.scss";

interface CardEpisodeRotatorInter {
  episode: any;
  gtmClass?: string;
}

const CardEpisodeRotator = (props: CardEpisodeRotatorInter) => {
  const { episode } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const handleDate = () => {
    let year = episode.fechaCreacion.slice(0, 4);
    let month = episode.fechaCreacion.slice(4, 6);
    let day = episode.fechaCreacion.slice(6, episode.fechaCreacion.length);

    let months = {
      "01": "ENE.",
      "02": "FEB.",
      "03": "MAR.",
      "04": "ABR.",
      "05": "MAY.",
      "06": "JUN.",
      "07": "JUL.",
      "08": "AGO.",
      "09": "SEP.",
      "10": "OCT.",
      "11": "NOV",
      "12": "DEC",
    };

    return `${day} DE ${months[month]} DE ${year}`;
  };

  return (
    <div className="a-card-episode-rotator">
      <a
        href={withPrefix(`libros/podcast/detalle/?podcast=${episode.mmsId}`)}
        className="a-card-episode-rotator__img"
      >
        <img
          src={episode.image?.file?.url || DefaultImage}
          alt={episode.image?.title ? 
            formatImageAlt(episode.image.title) : `Portada ${episode.titulo}`
          }
          className={`gtm${normalizeTwoWords(
            props.gtmClass
          )}Lectura${normalizeTwoWords(props.episode.titulo)}`}
        />
        <div className="a-card-episode-rotator__img-icon">
          <p className="icon-microphone a-card-episode-rotator__img-icon__shared"></p>
        </div>
      </a>

      <div className="a-card-episode-rotator__description">
        <span className="a-card-episode-rotator__description-date" onClick ={() => window.location.assign(withPrefix(`libros/podcast/detalle/?podcast=${episode.mmsId}`))}>
          {handleDate()}
        </span>
        <a
          className="a-card-episode-rotator__description-name"
          href={withPrefix(`libros/podcast/detalle/?podcast=${episode.mmsId}`)}
        >
          {episode.titulo}
        </a>
        <span className="a-card-episode-rotator__description-author">
          {episode.autor}
        </span>
      </div>

      <hr className="a-card-episode-rotator__separator" />

      <div className="a-card-episode-rotator__icons">
        <div
          className="a-card-episode-rotator__icons-share"
          onClick={toggleModal}
        >
          <p
            className={`icon-share a-card-episode-rotator__icons-share__icon gtm${normalizeTwoWords(
              props.gtmClass
            )}Lectura${normalizeTwoWords(props.episode.titulo)}Compartir`}
          ></p>
        </div>
      </div>

      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        href={withPrefix(`/podcasts/detalle/?podcast=${episode.mmsId}`)}
      />
    </div>
  );
};

export default CardEpisodeRotator;
